var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCovidCheckinAndOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.5h-3c-1.65 0-3 1.35-3 3v5c0 .95.65 1.7 1.5 1.95V27c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-6.55c.85-.2 1.5-1 1.5-1.95v-5c0-1.65-1.35-3-3-3zM26 15h-9v-1.5c0-1.65 1.35-3 3-3h3c1.65 0 3 1.35 3 3V15zM25.55 28h-8.1c-.55 0-1-.45-1-1v-4.35c0-.55.45-1 1-1h8.05c.55 0 1 .45 1 1V27c.05.55-.4 1-.95 1z",
    fill: "#EDF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2 3.55a1.65 1.65 0 100 3.3 1.65 1.65 0 000-3.3zM4.55 5.2a3.65 3.65 0 117.3 0 3.65 3.65 0 01-7.3 0zM21.7 3.55a1.65 1.65 0 100 3.3 1.65 1.65 0 000-3.3zM18.05 5.2a3.65 3.65 0 117.3 0 3.65 3.65 0 01-7.3 0zM29 16H13.5v-2H29v2zM3 16H1v-2h2v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 13.5c0-2.202 1.798-4 4-4h3c2.202 0 4 1.798 4 4v5c0 1.11-.6 2.1-1.5 2.618V27c0 1.102-.898 2-2 2H6c-1.102 0-2-.898-2-2v-5.903c-.873-.516-1.5-1.45-1.5-2.597v-5zm4-2c-1.098 0-2 .902-2 2v5c0 .457.309.851.782.99a1 1 0 01.718.96V27h4v-6.55a1 1 0 01.771-.973c.388-.092.729-.48.729-.977v-5c0-1.098-.902-2-2-2h-3zM20 11.5c-1.098 0-2 .902-2 2v.5h7v-.5c0-1.098-.902-2-2-2h-3zm-4 2c0-2.202 1.798-4 4-4h3c2.202 0 4 1.798 4 4V15a1 1 0 01-1 1h-9a1 1 0 01-1-1v-1.5zM15.45 22.65c0-1.102.898-2 2-2h8.05c1.102 0 2 .898 2 2v4.312c.075 1.164-.884 2.038-1.95 2.038h-8.1c-1.102 0-2-.898-2-2v-4.35zm10.05 0h-8.05V27h8.05v-4.35z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.324 20.5h2.451a1.24 1.24 0 00-1.225-1 1.24 1.24 0 00-1.226 1zm-2.024.25a3.24 3.24 0 013.25-3.25 3.24 3.24 0 013.25 3.25v.75a1 1 0 01-1 1h-4.5a1 1 0 01-1-1v-.75z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3 20.65a1 1 0 011 1V28a1 1 0 11-2 0v-6.35a1 1 0 011-1zM23.7 20.65a1 1 0 011 1V28a1 1 0 11-2 0v-6.35a1 1 0 011-1z",
    fill: props.color
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 21h8v8h-8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.242 20.757a6 6 0 10-8.486 8.487 6 6 0 008.486-8.487zM23.714 28l-2.384-2.384 1.212-1.212 1.172 1.172 3.532-3.532 1.212 1.212L23.714 28z",
    fill: "#54822B"
  })));
}

export default SvgIconCovidCheckinAndOut;